import React from 'react';
import cx from 'classnames';

import { IButtonFields } from '@/types/contentful';

import { ButtonColorTokenProp } from '../../../theme/tokens/button-color';
import { CFColorTokenProp } from '../../../theme/tokens/contentful-color';

const colorClasses = {
  sweetmint: {
    bg: 'bg-navy',
    text: 'text-white',
    hoverBg: 'hover:bg-navy',
    hoverText: 'hover:text-white'
  },
  spearmint: {
    bg: 'bg-spearmint',
    text: '',
    hoverBg: 'hover:bg-spearmint',
    hoverText: ''
  },
  cinnamint: {
    bg: 'bg-cinnamint',
    text: '',
    hoverBg: 'hover:bg-cinnamint',
    hoverText: ''
  },
  blackberry: {
    bg: 'bg-black',
    text: 'text-white',
    hoverBg: 'hover:bg-black',
    hoverText: 'hover:text-white'
  },
  white: { bg: 'bg-white', text: '', hoverBg: 'hover:bg-white', hoverText: '' },
  ginger: {
    bg: 'bg-ginger',
    text: '',
    hoverBg: 'hover:bg-ginger',
    hoverText: ''
  },
  green: { bg: 'bg-green', text: '', hoverBg: 'hover:bg-green', hoverText: '' },
  limegreen: {
    bg: 'bg-limegreen',
    text: '',
    hoverBg: 'hover:bg-limegreen',
    hoverText: ''
  }
} as const;

type ValidColorKeys = keyof typeof colorClasses;

function getButtonClasses(
  color: ButtonColorTokenProp | CFColorTokenProp | string
) {
  if (typeof color === 'string' && color in colorClasses) {
    return colorClasses[color as ValidColorKeys];
  }
  return { bg: '', text: '', hoverBg: '', hoverText: '' };
}

interface FormSubmitProps
  extends Partial<Omit<IButtonFields, 'buttonColor' | 'buttonHoverColor'>> {
  handleOnSubmit: () => void;
  buttonColor?: ButtonColorTokenProp | CFColorTokenProp;
  buttonHoverColor?: ButtonColorTokenProp | CFColorTokenProp;
}

export function FormSubmit({
  text,
  buttonColor = 'ginger',
  buttonHoverColor = 'green',
  handleOnSubmit
}: FormSubmitProps) {
  const buttonClasses = getButtonClasses(buttonColor as string);
  const buttonHoverClasses = getButtonClasses(buttonHoverColor as string);
  return (
    <button
      className={cx(
        'typography-body-2 mt-6 h-16 min-w-[146px] cursor-pointer appearance-none rounded-button-shape border-none px-3 font-medium outline-none transition duration-200',
        buttonClasses.bg,
        buttonClasses.text,
        buttonHoverClasses.hoverBg,
        buttonHoverClasses.hoverText
      )}
      onClick={handleOnSubmit}
      data-testid="split-module-form-submit"
    >
      {text || 'Submit'}
    </button>
  );
}
